import { render, staticRenderFns } from "./ReviewListRowDraggable.vue?vue&type=template&id=57fe2fe0&scoped=true&"
import script from "./ReviewListRowDraggable.vue?vue&type=script&lang=js&"
export * from "./ReviewListRowDraggable.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListRowDraggable.vue?vue&type=style&index=0&id=57fe2fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fe2fe0",
  null
  
)

export default component.exports